import client from './client';

export const getMe = () =>
  client.get('/users/me').then((r) => r.data);

export const updateMe = (data) =>
  client.put('/users/me', data).then((r) => r.data);

export const listUsers = (params) =>
  client.get('/users', { params }).then((r) => r.data);

export const updateUser = (id, data) =>
  client.put(`/users/${id}`, data).then((r) => r.data);

export const approveUser = (id) =>
  client.put(`/users/${id}/approve`, { is_approved: true }).then((r) => r.data);

// Set a user's tier role (promote/demote). Tenant-scoped + role-ceiling
// enforced server-side (FPA_ADMIN limited to FPA_USER ↔ FPA_ADMIN).
export const setUserRole = (id, role) =>
  client.put(`/users/${id}/role`, { role }).then((r) => r.data);

export const inviteUser = (data) =>
  client.post('/users/invite', data).then((r) => r.data);

// Re-send the branded, token-backed SES invitation (rotates the invite's
// single-use token, or mints a fresh invite if none survives). The user sets
// their password on the /invite/{token} landing page — no Cognito temp password.
export const resendInvite = (id) =>
  client.post(`/users/${id}/resend-invite`).then((r) => r.data);

// Admin-forced password reset: emails the user the same branded reset LINK as
// self-service "Forgot password" so they choose their own new password. No
// Cognito 6-digit code, no temp password.
export const resetPassword = (id) =>
  client.post(`/users/${id}/reset-password`).then((r) => r.data);
